export default "__VITE_ASSET__2xsm22rN__"